import { Button, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./driver_dashboard.css";
import { useNavigate, useParams } from "react-router";

import DriverService from "src/service/driver";
import User1 from "src/assets/images/profile/user-1.jpg";
import moment from "moment";
import BlankCard from "src/components/shared/BlankCard";
import AssignVehicle from "./AssignVehicle";
import TripDetails from "./TripDetails";
import { IconArrowBack } from "@tabler/icons";

const DriverDashboard = () => {
  const param = useParams();
  const [driver_data, setdriver_data] = useState([]);

  const navigate = useNavigate();

  const fetchDriverData = async () => {
    try {
      const res = await DriverService.getDriver({
        id: param.id,
      });
      setdriver_data(res.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDriverData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param.id]);

  const calculateAge = (dateOfBirth) => {
    const birthDate = moment(dateOfBirth);
    const currentDate = moment();
    const age = currentDate.diff(birthDate, "years");
    return age;
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item sm={12} md={12} lg={12} xs={12} mt={1}>
          <BlankCard>
            <CardContent
              className="flex justify-between align-middle"
              style={{ backgroundColor: "#ECF2FF" }}
            >
              <div>
                <Typography variant="h4" style={{ fontFamily: "sans-serif" }}>
                  Driver Profile
                </Typography>
                <Typography mt={1} style={{ fontSize: "14px" }}>
                  Driver &nbsp;&nbsp;&nbsp; ● &nbsp;&nbsp;&nbsp;
                  {driver_data?.driver_name || ""}
                </Typography>
              </div>
              <div>
                <Tooltip title="Back">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <IconArrowBack width={20} />
                  </Button>
                </Tooltip>
              </div>
            </CardContent>
          </BlankCard>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={1}>
          <div className="mt-3">
            <div className="wrapperd">
              <div className="profile-card js-profile-card">
                <div className="profile-card__img">
                  <img src={driver_data?.driver_image} alt={User1} />
                </div>

                <div className="profile-card__cnt js-profile-cnt">
                  <div className="profile-card__name">
                    {driver_data?.driver_name}
                  </div>

                  <div className="profile-card-loc">
                    <span className="profile-card-loc__icon">
                      <svg className="icon_d">
                        <use href="#icon-location"></use>
                      </svg>
                    </span>

                    <span className="profile-card-loc__txt">
                      {driver_data?.driver_address} , {driver_data?.pin_code}
                    </span>
                  </div>

                  <div className="container mt-6">
                    <div className="grid lg:grid-cols-3  md:grid-cols-2  sm:grid-cols-2 gap-3 mt-3">
                      <div className="">
                        <div className="profile-card-inf__title">
                          {driver_data?.driver_uniqueId}
                        </div>
                        <div className="profile-card-inf__txt">Unique ID</div>
                      </div>

                      <div>
                        <div className="profile-card-inf__title">
                          {driver_data?.driver_contact}
                        </div>
                        <div className="profile-card-inf__txt">Contact No</div>
                      </div>

                      <div>
                        <div className="profile-card-inf__title">
                          {moment(driver_data?.date_of_birth).format(
                            "DD-MM-YYYY"
                          )}
                        </div>
                        <div className="profile-card-inf__txt">
                          Date of Birth
                        </div>
                      </div>

                      <div>
                        <div className="profile-card-inf__title">
                          {calculateAge(driver_data?.date_of_birth)}
                        </div>
                        <div className="profile-card-inf__txt">Age</div>
                      </div>

                      <div className="profile-card-inf__item">
                        <div className="profile-card-inf__title">
                          {driver_data?.dl_no}
                        </div>
                        <div className="profile-card-inf__txt">DL No.</div>
                      </div>

                      <div className="profile-card-inf__item">
                        <div className="profile-card-inf__title">
                          {driver_data?.aadhar_no}
                        </div>
                        <div className="profile-card-inf__txt">Aadhar No</div>
                      </div>

                      <div className="profile-card-inf__item">
                        <div className="profile-card-inf__title">
                          {driver_data?.pan_no}
                        </div>
                        <div className="profile-card-inf__txt">Pan No</div>
                      </div>

                      <div className="profile-card-inf__item">
                        <div className="profile-card-inf__title">
                          {driver_data?.driver_email_id}
                        </div>
                        <div className="profile-card-inf__txt">Email ID</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <svg hidden="hidden">
              <defs>
                <symbol id="icon-location" viewBox="0 0 32 32">
                  <title>location</title>
                  <path d="M16 31.68c-0.352 0-0.672-0.064-1.024-0.16-0.8-0.256-1.44-0.832-1.824-1.6l-6.784-13.632c-1.664-3.36-1.568-7.328 0.32-10.592 1.856-3.2 4.992-5.152 8.608-5.376h1.376c3.648 0.224 6.752 2.176 8.608 5.376 1.888 3.264 2.016 7.232 0.352 10.592l-6.816 13.664c-0.288 0.608-0.8 1.12-1.408 1.408-0.448 0.224-0.928 0.32-1.408 0.32zM15.392 2.368c-2.88 0.192-5.408 1.76-6.912 4.352-1.536 2.688-1.632 5.92-0.288 8.672l6.816 13.632c0.128 0.256 0.352 0.448 0.64 0.544s0.576 0.064 0.832-0.064c0.224-0.096 0.384-0.288 0.48-0.48l6.816-13.664c1.376-2.752 1.248-5.984-0.288-8.672-1.472-2.56-4-4.128-6.88-4.32h-1.216zM16 17.888c-3.264 0-5.92-2.656-5.92-5.92 0-3.232 2.656-5.888 5.92-5.888s5.92 2.656 5.92 5.92c0 3.264-2.656 5.888-5.92 5.888zM16 8.128c-2.144 0-3.872 1.728-3.872 3.872s1.728 3.872 3.872 3.872 3.872-1.728 3.872-3.872c0-2.144-1.76-3.872-3.872-3.872z"></path>
                </symbol>
              </defs>
            </svg>
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} mt={2}>
          <BlankCard>
            <AssignVehicle />
          </BlankCard>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12} mt={2}>
          <BlankCard>
            <CardContent>
              <TripDetails />
            </CardContent>
          </BlankCard>
        </Grid>
      </Grid>
    </>
  );
};

export default DriverDashboard;
